import { connect } from 'react-redux'
import { browserHistory } from 'react-router';
import { change } from 'redux-form';
import { submitForm, stopSubmitForm, getNextStep, acceptContract } from '../actions/users';
import Contracts from '../components/Contracts';


const mapStateToProps = (state) => {
    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        submitContract(values, dispatch, ownProps) {
            return dispatch(acceptContract({...values, endpoint: ownProps.contractEndpoint})).then((result) => {
                if (result.error && result.payload.response.status !== 409) {
                    dispatch(change(ownProps.form, 'contract_accepted', false));
                }
            });
        },
        getStep(values, dispatch) {
            dispatch(submitForm());
            return dispatch(getNextStep()).then((result) => {
                if (typeof(result.payload.data.endpoint) !== "undefined") {
                    sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                    dispatch(stopSubmitForm());
                    browserHistory.push(result.payload.data.endpoint);
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Contracts);



/** WEBPACK FOOTER **
 ** ./src/containers/ContractsContainer.js
 **/